<template>
<div style="display:none">
    Connecting.
</div>
</template>

<script>
export default {
    mounted() {
        this.connectWithGithub();
    },

    methods: {
        connectWithGithub() {
            localStorage.authenticationToken = this.$route.query.token;
            localStorage.userId = this.$route.query.user_id;
            localStorage.email = this.$route.query.email;

            this.$router.push({ name: 'dashboard' });
        },
    },
}
</script>
